import {
  Transforms
} from 'slate';

import * as serializer from 'basic-editor-value-serializer';

import types from '../../elements/types';

const listTypes = [
  types.BULLETED_LIST,
  types.NUMBERED_LIST
];

function getListItemType(listType) {

  if (listType === types.BULLETED_LIST) {
    return types.BULLETED_LIST_ITEM;
  } else if (listType === types.NUMBERED_LIST) {
    return types.NUMBERED_LIST_ITEM;
  }

}

function withListSchema(editor) {

  const { normalizeNode } = editor;

  editor.normalizeNode = function _normalizeNode([node, path]) {

    if (listTypes.includes(node.type) === true) {

      const items = node.children;
      const itemsLength = items.length;
      const expectedListItemType = getListItemType(node.type);

      for (let index = 0; index < itemsLength; index++) {
        const item = items[index];
        const itemPath = path.concat([index]);

        if (item.type !== expectedListItemType) {

          if (serializer.allTypes.topLevelElements.includes(item.type) === true) {
            Transforms.liftNodes(editor, { at: itemPath });
            return;
          }
        }
      }
    }

    normalizeNode([node, path]);

  };

  return editor;
};

export default withListSchema;